/**
 * エラーコードに表示するための、リソースに対するID定義
 */
// ルート名に対するID
const ROUTE_DEFS = {
  Login: { id: 'W01', title: 'ログイン' },
  NoSupportBrowser: { id: 'W41', title: '推奨ブラウザ以外のページ' },
  LoginCooperation: { id: 'W64', title: 'SSOログイン' },
  LoginCooperationFromApp: { id: 'W65', title: 'アプリからSSOログイン' },
  LoginStartFromXgrab: { id: 'W66', title: 'SSOログイン（Xgrabから遷移）' },
  LoginStartFromXgrabConstruction: { id: 'W68', title: 'SSOログイン（Xgrabから遷移）プロジェクトID指定' },
  HandleXgrabAuthCode: { id: 'W67', title: 'SSOログインリダイレクト先' },
  AppWebViewExited: { id: 'W63', title: 'アプリのWebViewを閉じたときの画面' },
  OpenUpdateHistory: { id: 'W69', title: '更新記録開く' },
  OpenExternalSite: { id: 'W70', title: '外部ページを開く' },
  OpenSupport: { id: 'W71', title: 'サポートページ' },
  OpenTalk: { id: 'W72', title: 'トーク開く' },
  InviteMember: { id: 'W73', title: 'メンバー追加' },
  ShareDaicho: { id: 'W74', title: '台帳共有' },
  DaichoView: { id: 'W75', title: '台帳ビュー' },
  Registration: { id: 'W02', title: 'アカウント作成' },
  Invitation: { id: 'W02', title: 'アカウント作成' },
  ReceiveKokubanInvitation: { id: 'W02', title: 'アカウント作成' },
  RequestRegistration: { id: 'W31', title: 'アカウント登録依頼' },
  RequestRegistrationComplete: { id: 'W32', title: 'アカウント登録依頼' },
  RequestRegistrationCancel: { id: 'W33', title: 'アカウント登録依頼' },
  RequestRegistrationError: { id: 'W34', title: 'アカウント登録依頼' },
  RequestTemporaryRegistration: { id: 'W37', title: 'アカウント登録依頼 iOS' },
  RequestTemporaryRegistrationFromPage: { id: 'W51', title: 'アカウント登録依頼 Web' },
  RequestTemporaryRegistrationKuraemonCamera: { id: "W62", title: 'アカウント登録申請（蔵衛門カメラ）' },
  RequestInvitation: { id: 'W40', title: 'アカウント招待申請' },
  FinalRegistration: { id: 'W35', title: 'アカウント登録' },
  DirectInvitation: { id: 'W36', title: 'アカウント招待' },
  RequestPasswordResetForm: { id: 'W03', title: 'パスワード忘れ' },
  RequestPasswordResetComplete: { id: 'W03', title: 'パスワード忘れ' },
  ResetPasswordForm: { id: 'W04', title: 'パスワード再設定' },
  KuraemonApps: { id: 'W29', title: 'アプリ一覧' },
  ConstructionList: { id: 'W05', title: '工事選択' },
  AccountSetting: { id: 'W06', title: 'アカウント設定' },
  AccountPlan: { id: 'W07', title: 'アカウントプラン' },
  MemberList: { id: 'W08', title: 'メンバー管理' },
  PhotoList: { id: 'W09', title: '写真一覧' },
  PhotoTabs: { id: 'W53', title: '写真タブ一覧' },
  KokubanList: { id: 'W10', title: '黒板一覧' },
  ZumenList: { id: 'W11', title: '図面一覧' },
  BookrackList: { id: 'W52', title: '本棚一覧' },
  DeletedPhotoList: { id: 'W12', title: '削除した項目写真' },
  DeletedKokubanList: { id: 'W13', title: '削除した項目黒板' },
  DeletedZumenList: { id: 'W14', title: '削除した項目図面' },
  DeletedMemberList: { id: 'W15', title: '削除した項目メンバー' },
  ChangeMail: { id: 'W16', title: 'メールアドレス変更' },
  RequestPixRegistration: { id: 'W23', title: 'Pixアカウント登録申請' },
  PhotoDetail: { id: 'W17', title: '写真詳細' },
  PhotoTabDetail: { id: 'W54', title: '写真タブ詳細' },
  KokubanDetail: { id: 'W18', title: '黒板詳細' },
  KokubanPhotoList: { id: 'W19', title: '黒板の写真一覧' },
  KokubanPhotoDetail: { id: 'W20', title: '黒板の写真詳細' },
  ZumenPageList: { id: 'W21', title: '図面ページ一覧' },
  ZumenPageDetail: { id: 'W22', title: '図面ページ詳細' },
  ReceiveKokuban: { id: 'WC01', title: '黒板受け取り' },
  ReceiveKokubanToken: { id: 'WC01', title: '黒板受け取りトークン' },
  CreateConstruction: { id: 'W24', title: '工事名と要領区分設定' },
  SelectGuideline: { id: 'W25', title: '要領選択' },
  SelectSubGuideline: { id: 'W26', title: '準拠する要領選択' },
  SelectBroadCategory: { id: 'W30', title: '写真整理情報の大分類選択' },
  ConstructionSetting: { id: 'W38', title: '工事設定' },
  AddMemberPermissionSetting: { id: 'W39', title: 'メンバー追加権限設定' },
  KokubanDefaultSetting: { id: 'W47', title: '黒板作成時の規定値' },
  ManagementConstructionNameSetting: { id: 'W61', title: '管理用工事名' },
  NewPhotoEditor: { id: 'W27', title: '新規写真の編集' },
  UpdatePhotoEditor: { id: 'W28', title: '既存写真の編集' },
  FormList: { id: 'W55', title: 'フォーム一覧' },
  CreateForm: { id: 'W60', title: 'フォーム作成' },
  FormDetail: { id: 'W56', title: 'フォーム詳細' },
  FormAnswerList: { id: 'W57', title: '回答一覧' },
  DeletedFormList: { id: 'W59', title: '削除した項目フォーム' },
}
// APIアクション名に対するID
const API_IDS = {
  // アカウント仮登録情報取得API
  getTemporaryAccount: 'A02',
  // アカウント本登録_起動API
  registerAccount1: 'A24',
  // アカウント本登録_確認API
  registerAccount2: 'A25',
  // アカウント仮登録要求API
  registerTemporaryAccountRequest: 'A20',
  // 期限切れアカウント本登録再申請API
  reapplyExpiredAccountRequest: 'A22',
  // 招待/データ共有内容取得API
  getInviteShareInfo: 'A21',
  // パスワード再設定メール送信API
  sendAccountPasswordResetMail: 'A04',
  // パスワード再設定情報取得API
  getResetPasswordAccount: 'A05',
  // パスワード再設定API
  resetAccountPassword: 'A06',
  // アカウントログインAPI
  loginAccount: 'A07',
  // アカウントログインチェックAPI
  checkLoginAccount: 'A08',
  // アカウント仮登録要求状況確認API
  getTemporaryAccountRequestStatus: 'A23',
  // アカウントログアウトAPI
  logoutAccount: 'A09',
  // アカウント情報取得API
  getAccountInfo: 'A10',
  // アカウント情報更新API
  updateAccountInfo: 'A11',
  // メールアドレス変更API
  changeMailAddress: 'A13',
  // パスワード変更API
  changePassword: 'A14',
  // ユーザーアイコンアップロードURL取得API
  getAccountIconUploadUrl: 'A15',
  // アカウントライセンス登録API
  registerAccountLicense: 'A17',
  // アカウントライセンス情報取得API
  getAccountLicense: 'A18',
  // アカウントログインAPI
  loginKobito: 'A16',
  // 解約アンケート登録API
  registerAnswerCancelQuestionnaire: 'A19',
  // アカウント2要素認証設定登録API
  registerAccountTfaSetting: 'A26',
  // トークンからアカウント登録情報取得API
  getTemporaryAccountRequestInfo: 'A27',
  // トークンからアカウント仮登録要求API
  registerTemporaryAccountRequestWithToken: 'A28',
  // トーク通知メール設定取得API
  getTalkNotificationMailSetting: 'A29',
  // トーク通知メール設定更新API
  setTalkNotificationMailSetting: 'A30',
  // SSO連携情報取得API
  getCooperationInfos: 'A31',
  // SSO方式取得API  
  getSsoMethod: 'A32',
  // XgabアカウントでログインAPI
  loginXgrabAccount: 'A33',
  // SSOログインAPI
  loginWithSso: 'A34',
  // 運用管理画面ログインURL取得API
  getEnterpriseManageLoginUrl: 'A35',


  // クラウド工事一覧取得2API
  getCloudConstructionList2: 'C77',
  // バナー情報取得API
  getBannerInfo: 'O10',
  // クラウド工事作成API
  createCloudConstruction: 'C01',
  // クラウド工事メンバー追加API
  addMemberToCloudConstruction: 'C03',
  // クラウド工事メンバー複数追加API
  bulkAddMemberMailToCloudConstruction: 'C51',
  // 工事追加メンバーチェックAPI
  checkAddMemberMail: 'C52',
  // 工事追加複数メンバーチェックAPI
  checkAddMemberMultipleMail: 'C72',
  // クラウド工事メンバー削除API
  deleteMemberToCloudConstruction: 'C04',
  // 工事メンバー権限変更API
  changeMemberPermissions: 'C22',
  // 招待工事トークン解決API
  canJoinInvitedCloudConstructionMember: 'C23',
  // 招待工事だけにするAPI
  joinCloudConstructionMemberOnlyInvite: 'C24',
  // クラウド工事情報取得API
  getCloudConstruction: 'C05',
  // クラウド工事情報更新API
  updateCloudConstruction: 'C27',
  // 黒板情報登録API
  registerKokubanInfo: 'C07',
  // 黒板一覧取得API
  getKokubanList: 'C08',
  // 写真情報登録API
  registerPhotoInfo: 'C09',
  // 写真一覧取得API
  getPhotoList: 'C10',
  // 写真一括ダウンロード開始API
  startBulkDownloadPhoto: 'C25',
  // 写真一括ダウンロードチェックAPI
  checkBulkDownloadPhoto: 'C26',
  // クラウド工事データ共有API
  shareCloudConstructionData: 'C13',
  // クラウド工事データ複数ユーザー共有API（web用）
  bulkShareMailCloudConstructionData: 'C56',
  // クラウド工事参加申請受付確認API
  receiveRequestJoinCloudConstruction: 'C14',
  // クラウド工事参加承認API
  confirmJoinCloudConstruction: 'C15',
  // クラウド工事QRコード作成API
  createCloudConstructionQrcode: 'C16',
  // クラウド工事QRコードWEB情報取得API
  getCloudConstructionQrcodeWebInfo: 'C17',
  // 写真群取得API
  getPhotoSet: 'C20',
  // 図面キャプチャによって生成された写真作成API
  createPhotoZumenCapture: 'C21',
  // 蔵衛門黒板V1セット取得API
  getKokubanSet: 'C44',
  // アップロード写真作成（WEB用）API
  createPhotoForWeb: 'C53',
  // 写真アップロード完了登録（WEB用）API
  registerUploadPhotoFinishForWeb: 'C54',
  // アップロード写真作成完了待ち（WEB用）API
  uploadPhotoPollingForWeb: 'C55',
  // 写真一覧ページ構造取得API
  getPhotoViewStructure: 'C59',
  // トークン有効期限確認API
  checkTokenActive: 'O01',
  // WEBバージョン取得API
  getKuraemonCloudWebPageVersion: 'O03',
  // 蔵衛門アプリダウンロードURLリストAPI
  getAppDownloadUrlList: 'O04',
  // 図面リスト取得API
  getZumenList: 'Z04',
  // 図面エンティティリスト取得API
  getZumenEntityList: 'Z05',
  // 図面ページリスト取得API
  getZumenPageList: 'Z06',
  // 空フォルダ作成API
  createZumenFolder: 'Z08',
  // 図面作成API
  createZumen: 'Z09',
  // 図面変更API
  modifyZumen: 'Z10',
  // 図面フォルダ移動API
  moveZumenFolder: 'Z11',
  // 図面削除API
  deleteZumen: 'Z13',
  // 図面復元API
  restoreZumen: 'Z14',
  // 図面ビューワー起動トークン取得API
  getZumenViewerWakeupToken: 'Z01',
  // キャプチャ図面作成API
  createCaptureZumen: 'Z15',
  // お知らせ一覧取得API
  getNotificationList: 'O05',
  // クラウド工事本棚情報ツリー取得API
  getCloudConstructionBookrackInfoTree: 'C57',
  // クラウド工事本棚アイテム存在確認API
  existsCloudConstructionBookrackItem: 'C70',
  // サポートURL取得API
  getSupportUrl: 'O11',
  // ビデオトークチャンネル取得API
  getVideoTalkChannel: 'V03',
  // ビデオトーク画面スクリーンショット写真作成API
  createPhotoVideoTalkScreenshot: 'V04',
  // フォーム一覧取得API
  getFormList: 'C60',
  // フォーム情報取得API
  getFormInfo: 'C69',
  // フォーム削除API
  deleteForm: 'C61',
  // フォーム作成API
  createForm: 'C62',
  // フォーム編集API
  updateForm: 'C63',
  // QRコードPDF作成API
  createFormQrcodePdf: 'C64',
  // フォーム出力設定API
  updateFormOutputSetting: 'C65',
  // レポート作成API
  createFormReport: 'C66',
  // 回答一覧取得API
  getFormAnswerList: 'C67',
  // 回答削除API
  deleteFormAnswer: 'C68',
  // フォーム復元API
  restoreForm: 'C71',
  // 回答レコード編集API
  updateFormAnswerRecord: 'C73',
  // 一括新規レコード作成API
  bulkCreateNewRecord: 'C74',
  // 一括新規レコード作成状況チェックAPI 
  bulkCreateNewRecordPolling: 'C75',
  // 黒板一覧ページ構造取得API
  getKokubanViewStructure: 'C76',
  // TODO: ask for id of api
  getPhotoOrganizeInfoTree: 'C77',
  updatePhotoOrganizeInfoTree: 'C78',
  // クラウド工事一覧取得3API
  getCloudConstructionList3: 'C79',
  // クラウド工事メンバー一覧取得API
  getCloudConstructionMembers: 'C80',
  // 取り込みマスタ(TreeSource)保存API
  saveTreeSource: 'C81',
  // 取り込みマスタ(TreeSource)取得API
  getTreeSource: 'C82',
  // 取り込みマスタ(TreeSource)一覧取得API（工事単位・メタデータのみ）
  getTreeSourceListByConstruction: 'C83',
  // 取り込みマスタ(TreeSource)削除API
  deleteTreeSource: 'C84',
  // 招待済み未参加工事一覧取得API
  getInvitedCloudConstructionList: 'C85',
  // 工事招待への参加/拒否API
  respondCloudConstructionInvite: 'C86',
}
/**
 * IDを返す.
 * @param ids 
 * @param key 
 * @returns IDの定義がある場合はID, ない場合はkey.
 */
const valueFrom = (ids: {[key: string]: string}, key: string) => {
  if(ids[key] || ids[key] === '') return ids[key];
  return key;
}

const ROUTE_IDS = Object.fromEntries(Object.entries(ROUTE_DEFS).map(([key, val]) => ([key, val.id])))
/**
 * ルート名に対するIDを返す.
 * @param routeName ルート名
 * @returns ルート名に対するID
 */
export const routeIdOf = (routeName: string) => (valueFrom(ROUTE_IDS, routeName))

const ROUTE_TITLES = Object.fromEntries(Object.entries(ROUTE_DEFS).map(([key, val]) => ([key, val.title])))
/**
 * ルート名に対するIDを返す.
 * @param routeName ルート名
 * @returns ルート名に対するID
 */
export const routeTitleOf = (routeName: string) => (valueFrom(ROUTE_TITLES, routeName))

/**
 * API名に対するIDを返す.
 * @param apiName API名
 * @returns API名に対するID
 */
export const apiIdOf = (apiName: string) => (valueFrom(API_IDS, apiName))
